import { render, staticRenderFns } from "./SplitWithoutSubhireLegRateDialog.vue?vue&type=template&id=db0fa844"
import script from "./SplitWithoutSubhireLegRateDialog.vue?vue&type=script&lang=js"
export * from "./SplitWithoutSubhireLegRateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports